import { createSelector } from 'reselect';
import { editListingSelector } from 'store/state/domainData/selectors/editListing';
import { bulletinToFormValues } from 'utils/uploadBulletin';

export const initialValuesSelector = createSelector([ editListingSelector ], poi => poi ? bulletinToFormValues(poi) : null);
